<template>
    <div
        class="absolute inset-0 flex items-center justify-center z-60 pointer-events-none"
        v-if="loading"
    >
        <div
            class="w-12 h-12 p-1 rounded-full flex justify-center items-center"
            :class="{
                'bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50': !noBackground,
                'bg-transparent shadow-none': noBackground,
                'w-12 h-12': size === 'large',
                'w-8 h-8': size === 'medium',
                'w-5 h-5': size === 'small',
            }"
            role="status"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                height="600"
                width="600"
                x="0"
                y="0"
                viewBox="0 0 600 600"
                class="map-spinner"
            >
                <defs>
                    <linearGradient
                        id="Gradient1"
                        gradientTransform="rotate(90)"
                    >
                        <stop offset="0%" stop-color="rgba(255, 84, 0, 1)" />
                        <stop
                            offset="100%"
                            stop-color="rgba(255, 84, 0, 0.5)"
                        />
                    </linearGradient>
                    <linearGradient
                        id="Gradient2"
                        gradientTransform="rotate(90)"
                    >
                        <stop
                            offset="0%"
                            stop-color="rgba(246, 246, 246, 0)"
                            stop-opacity="0"
                        />
                        <stop offset="90%" stop-color="rgba(255, 84, 0, 0.5)" />
                        <stop
                            offset="100%"
                            stop-color="rgba(255, 84, 0, 0.65)"
                        />
                    </linearGradient>
                    <pattern
                        id="Pattern"
                        x="0"
                        y="0"
                        width="600"
                        height="600"
                        patternUnits="userSpaceOnUse"
                    >
                        <g transform="rotate(0, 300, 300)">
                            <rect
                                shape-rendering="crispEdges"
                                x="0"
                                y="0"
                                width="300"
                                height="600"
                                fill="url(#Gradient1)"
                            />
                            <rect
                                shape-rendering="crispEdges"
                                x="300"
                                y="0"
                                width="300"
                                height="600"
                                fill="url(#Gradient2)"
                            />
                        </g>
                    </pattern>
                </defs>
                <path
                    class="map-spinner-rotating"
                    style="stroke: url(#Pattern)"
                    fill="transparent"
                    transform="rotate(105, 300, 300)"
                    stroke-width="60"
                    d="M 364 58 A 250 250 0 1 1 235 58"
                />
            </svg>
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        loading: Boolean,
        size: {
            type: String,
            default: 'large',
        },
        noBackground: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style>
.map-spinner {
    margin: -24px 00 -24px;
}
@keyframes rotate {
    from {
        transform: rotate(105deg);
    }
    to {
        transform: rotate(465deg);
    }
}
.map-spinner-rotating {
    animation-name: rotate;
    animation-duration: 1200ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    transform-origin: 300px 300px;
}
</style>
